/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import config from 'linced-admin/config/environment';
import moment from 'moment';

export default class NzReportController extends Controller {
  @service
  fetch;

  @tracked
  selectedYear = moment().year();

  @action
  setSelectedYear(value) {
    this.selectedYear = value;
  }

  @computed
  get yearOptions() {
    let year = moment().year();
    let options = [];
    while (year >= 2020) {
      options.unshift(year);
      year--;
    }
    return options;
  }

  @tracked
  reportGenerating = false;

  @action
  generateReport() {
    this.reportGenerating = true;
    let data = JSON.stringify({ year: this.selectedYear });
    return this.fetch
      .post(`${config.APP.apiHost}/finance/v4/reports/nz/:generate`, { data })
      .then((response) => {
        let link = document.createElement('a');
        link.href = `data:text/csv,${response.data}`;
        link.download = `hero-finance-${this.selectedYear}.csv`;
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        this.reportGenerating = false;
      });
  }
}
